import { render, staticRenderFns } from "./SelectedOption.vue?vue&type=template&id=49d565fa&scoped=true&"
import script from "./SelectedOption.vue?vue&type=script&lang=ts&"
export * from "./SelectedOption.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedOption.vue?vue&type=style&index=0&id=49d565fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d565fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\rafael\\Github\\MultiSelect\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d565fa')) {
      api.createRecord('49d565fa', component.options)
    } else {
      api.reload('49d565fa', component.options)
    }
    module.hot.accept("./SelectedOption.vue?vue&type=template&id=49d565fa&scoped=true&", function () {
      api.rerender('49d565fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiSelect/SelectedOption.vue"
export default component.exports